import { TableCell, TableRow, TableHead } from '@mui/material';
import { styled } from '@mui/system';

const StyledTableHead = styled(TableHead)({
  backgroundColor: '#f8f9fa', // Light grey background for the header
});

const BoldTableCell = styled(TableCell)({
  fontWeight: 'bold',
  borderBottom: '1px solid #dee2e6', // Light grey bottom border
  margin: "50% 0",
});

const CellWithBorderStyle = styled(TableCell)({
  borderBottom: '1px solid #dee2e6', // Light grey bottom border
});

function SustainabilityTableHeader() {
  return (
    <StyledTableHead>
      <TableRow>
        <BoldTableCell align="center">Continent</BoldTableCell>
        <BoldTableCell align="center">Country</BoldTableCell>
        <BoldTableCell align="center">Region</BoldTableCell>
        <BoldTableCell align="center">Carbon Intensity</BoldTableCell>
        <BoldTableCell align="center">Fossil Fuel Percentage (%)</BoldTableCell>
      </TableRow>
      <TableRow>
        <CellWithBorderStyle></CellWithBorderStyle>
        <CellWithBorderStyle></CellWithBorderStyle>
        <CellWithBorderStyle></CellWithBorderStyle>
        <CellWithBorderStyle></CellWithBorderStyle>
        <CellWithBorderStyle></CellWithBorderStyle>
      </TableRow>
    </StyledTableHead>
  );
}

export default SustainabilityTableHeader;
